module.exports = __webpack_public_path__ + "assets/img/675c138a11caa47fb1d852d3bf0dec56.svg";